import { Button } from '@mantine/core';
import { IconFileTypeDocx } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

const onDownload = () => {
  window.open(`/api/research-centers/report/latest/docx`);
};

export function AllCentersReportButton() {
  const { t } = useTranslation();
  return (
    <Button
      size="xs"
      leftSection={<IconFileTypeDocx size="24px" />}
      onClick={() => onDownload()}
    >
      {t('researchCenters.report.downloadAll')}
    </Button>
  );
}
